import { client } from '../client';
import { CryptoTransfer } from '~/typings/API';

import type { GetRequestType } from './WireDrawdownRepository';

export type { CryptoTransfer };

export class CryptoRepository {
  static async get(request: GetRequestType) {
    return client.get<unknown, CryptoTransfer>(`/transfers/crypto/${request.id}`);
  }
}
